import { createContext, Dispatch, SetStateAction, useContext } from "react"

/**
 * reporting year possible values:
 *
 * - undefined: loading
 * - null: reporting year does not exist
 * - number: set
 */
export const ReportingYearContext = createContext<{
  reportingYear: number | null | undefined
  setReportingYear: Dispatch<SetStateAction<number | null | undefined>>
}>({
  reportingYear: undefined,
  setReportingYear: () => alert("Used outside of a provider"),
})

export const useReportingYear = () => useContext(ReportingYearContext)
export default useReportingYear
